<template>
  <div class="labelled-field-alt">
    <div
      v-if="!hideLabel"
      :class="['text-truncate p p-bold label', { 'label-tooltip': tooltipText }]"
    >
      {{ label }}
      <v-tooltip
        v-if="tooltipText"
        bottom
      >
        <template v-slot:activator="{ on, attrs }">
          <v-img
            :src="'./assets/icons/icn-help.svg'"
            class="icn-help tooltip ml-2"
            height="24"
            width="24"
            v-bind="attrs"
            v-on="on"
          />
        </template>
        <span>{{ tooltipText }}</span>
      </v-tooltip>
    </div>
    <div
      v-if="formattedValue"
      :class="{ isError: isErrorState }"
      class="text-truncate h-5 mt-1 value"
    >
      <span v-if="isErrorState">⚠️</span>
      {{ formattedValue }}
    </div>
    <div
      v-else
      class="text-truncate h-5 mt-1 non-available"
    >
      <span
        v-if="isRequired"
        class="missing-data"
      >
        ⚠️
        {{ $t('common.missing-data') }}
      </span>
      <span v-else>
        {{ $t('common.optionnal') }}
      </span>
    </div>
    <div
      v-if="isErrorState"
      class="text-truncate p isError"
    >
      {{ $t('main.enums.error.non-valid-data') }}
    </div>
  </div>
</template>

<script type="text/javascript">
  import { FORMAT } from './LabelledField.const'

  export default {
    props: {
      label: {
        type: String,
        default: '',
      },
      value: {
        type: [String, Number,],
        default: null,
      },
      hideLabel: {
        type: Boolean,
        default: false,
      },
      isError: {
        type: Boolean,
        default: null,
      },
      isRequired: {
        type: Boolean,
        default: false,
      },
      format: {
        type: String,
        default: null,
      },
      color: {
        type: String,
        default: null,
      },
      tooltipText: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        FORMAT,
      }
    },
    computed: {
      isErrorState() {
        return this.isError !== null && !this.isError
      },
      formattedValue() {
        if (this.value === 'null') {
          return null
        }

        if (this.format !== null) {
          if (this.format === FORMAT.currency) {
            return this.$n(this.value, 'currency', 0)
          } else if (this.format === FORMAT.currency_full) {
            return this.$n(this.value, 'currency', 2)
          } else if (this.format === FORMAT.percentage) {
            return `${parseInt(this.value, 10)} %`
          } else if (this.format === FORMAT.percentage_full) {
            return `${parseFloat(this.value).toFixed(2)} %`
          }
        }

        return this.value
      },
    },
  }
</script>

<style lang="scss" scoped>
.label {
  color: $color-102d69;
  &-tooltip {
    align-items: center;
    display: inline-flex;
  }
  .tooltip {
    display: inline-grid;
    display: inline-flex;
  }
}
.value {
  color: $color-004f9f;
}
.isError {
  color: $color-ff524f;
}
.non-available {
  color: $color-49495c;
}
.missing-data {
  color: $color-f07d00;
}
</style>
